import React from 'react';
import {Link} from 'react-router-dom';
import Moment from 'moment';
import InputMoment from 'input-moment';
import DatePicker from 'react-datepicker';
import SimpleModal from '../commons/modals/SimpleModal';
import PlacePicker from '../commons/place-picker/PlacePicker';
import QuantitySelector from '../commons/quantity-selector/QuantitySelector';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'

export const slots = {
  morning: [9, 12],
  afternoon: [12, 15],
  evening: [15, 21],
};

class DeliveryDetailsMobile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deliveryTimePickerVisibility: false,
      recipientAddressPickerModalVisibility: false,
      senderAddressPickerModalVisibility: false
    }

    this.renderGiftDeliverySwitchRow = this.renderGiftDeliverySwitchRow.bind(this)
    this.renderDeliveryToAddress = this.renderDeliveryToAddress.bind(this)
    this.renderGiftDeliveryAddress = this.renderGiftDeliveryAddress.bind(this)
    this.renderDeliveryNotes = this.renderDeliveryNotes.bind(this)
    this.renderScheduleDelivery = this.renderScheduleDelivery.bind(this)
    this.onSelectCustomTimeRequest = this.onSelectCustomTimeRequest.bind(this);
    this.renderDeliveryScheduleInfo = this.renderDeliveryScheduleInfo.bind(this)
    this.renderContentForViewOnlyMode = this.renderContentForViewOnlyMode.bind(this)
    this.onSelectRecipientAddress = this.onSelectRecipientAddress.bind(this)
    this.onSelectSenderAddress = this.onSelectSenderAddress.bind(this)
  }

  render() {
    const {viewMode, isGiftSwitchOn, deliveryTime, onDeliveryTimeSelected,
      onChangeDeliveryDetailsForm, giftDeliveryDetails, deliverySlot, deliveryValidationStatus, shippoData } = this.props;
    const {deliveryTimePickerVisibility, recipientAddressPickerModalVisibility,
      senderAddressPickerModalVisibility} = this.state;
    return (
      <div className="item-list-mobile delivery-details-mobile ">
        {viewMode && (viewMode === 'select' || viewMode === 'edit') ? (
          <div>
            {this.renderGiftDeliverySwitchRow()}
            {!isGiftSwitchOn ? this.renderDeliveryToAddress() : this.renderGiftDeliveryAddress()}
            {this.renderDeliveryNotes()}
            {this.renderScheduleDelivery()}
          </div>
        ) : this.renderContentForViewOnlyMode()}
        {this.renderDeliveryScheduleInfo()}
        {deliveryTimePickerVisibility ? (
          <SimpleModal
            customClass={`date-time-picker-modal ${deliveryValidationStatus && deliveryValidationStatus.time && !isGiftSwitchOn ? 'date-options-hidden': ''} `}
            onCloseRequest={() => this.setState({ deliveryTimePickerVisibility: false })}>
            <InputMoment
              moment={deliveryTime}
              onChange={(m) =>  onDeliveryTimeSelected ? onDeliveryTimeSelected(m) : null}
              prevMonthIcon="fa fa-angle-left"
              nextMonthIcon="fa fa-angle-right"/>
              <div className="button button-blue button-block"
                onClick={() => this.setState({deliveryTimePickerVisibility: false})}>Done</div>
          </SimpleModal>
        ) : null}

        {recipientAddressPickerModalVisibility ?
          <SimpleModal onCloseRequest={() => this.setState({recipientAddressPickerModalVisibility: false})}>
            <PlacePicker
              onPlaceSelect={() => { }}
              onSubmit={this.onSelectRecipientAddress}
              deliveryValidation={'GIFT'} />
          </SimpleModal>
          : null }

        {senderAddressPickerModalVisibility ?
          <SimpleModal onCloseRequest={() => this.setState({senderAddressPickerModalVisibility: false})}>
            <PlacePicker
              onPlaceSelect={() => { }}
              onSubmit={this.onSelectSenderAddress} />
          </SimpleModal>
          : null }
      </div>
    )
  }

  onSelectRecipientAddress(address, deliveryValidationStatus) {
    const {onRecipientAddressSelected} = this.props;
    this.setState({recipientAddressPickerModalVisibility: false, deliveryValidationStatus}, () => {
      if(!!onRecipientAddressSelected) {
        onRecipientAddressSelected(address, deliveryValidationStatus)
      }
    })
  }

  onSelectSenderAddress(address) {
    const {onSenderAddressSelected} = this.props;
    this.setState({senderAddressPickerModalVisibility: false}, () => {
      if(!!onSenderAddressSelected) {
        onSenderAddressSelected(address)
      }
    })
  }

  renderContentForViewOnlyMode() {
    const {deliveryAddress, deliveryNotes, isTimeNowSelected, deliveryTime, isGiftSwitchOn, giftDeliveryDetails} = this.props;
    return (
      <div>
        {!isGiftSwitchOn ? (
          <div className="row">
            <div className="info-row">
              <div className="content-left has-label">
                <div className="info-row-label">Delivery To</div>
                <div className="info-row-value">{deliveryAddress
                    ? deliveryAddress.apartment ? `Apartment #: ${deliveryAddress.apartment}, ${deliveryAddress.description}` : deliveryAddress.description
                    : 'Not provided'}</div>
              </div>
            </div>
          </div>
        ) : (
          <div className="gift-delivery-details-container">
            <div className="row recipient-details-row">
              <div className="info-row">
                <div className="content-left">
                  <div className="info-row-label">Gift Delivery Recipient Details</div>
                  <div className="info-row-value">
                    {giftDeliveryDetails.recipientName ? (
                      <div className="description">{giftDeliveryDetails.recipientName}</div>
                    ) : null}
                    {giftDeliveryDetails.recipientBusinessName ? (
                      <div className="description">{giftDeliveryDetails.recipientBusinessName}</div>
                    ) : null}
                    {giftDeliveryDetails.recipientAddress ? (
                      <div className="description">
                        {giftDeliveryDetails.recipientAddress.apartment ? `Apartment #: ${giftDeliveryDetails.recipientAddress.apartment} ` : ''}
                        {giftDeliveryDetails.recipientAddress.description}
                      </div>
                    ) : null}
                    {giftDeliveryDetails.recipientEmail ? (
                      <div className="description">{giftDeliveryDetails.recipientEmail}</div>
                    ) : null}
                    {giftDeliveryDetails.recipientPhone ? (
                      <div className="description">{giftDeliveryDetails.recipientPhone}</div>
                    ) : null}
                    {giftDeliveryDetails.giftMessage ? (
                      <div className="description">{`GIFT MESSAGE: ${giftDeliveryDetails.giftMessage}`}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="row recipient-details-row">
              <div className="info-row">
                <div className="content-left">
                  <div className="info-row-label">Gift Delivery Sender Details</div>
                  <div className="info-row-value">
                    {giftDeliveryDetails.senderName ? (
                      <div className="description">{giftDeliveryDetails.senderName}</div>
                    ) : null}
                    {giftDeliveryDetails.senderBusinessName ? (
                      <div className="description">{giftDeliveryDetails.senderBusinessName}</div>
                    ) : null}
                    {giftDeliveryDetails.senderAddress ? (
                      <div className="description">
                        {giftDeliveryDetails.senderAddress.apartment ? `Apartment #: ${giftDeliveryDetails.senderAddress.apartment} ` : ''}
                        {giftDeliveryDetails.senderAddress.description}
                      </div>
                    ) : null}
                    {giftDeliveryDetails.senderEmail ? (
                      <div className="description">{giftDeliveryDetails.senderEmail}</div>
                    ) : null}
                    {giftDeliveryDetails.senderPhone ? (
                      <div className="description">{giftDeliveryDetails.senderPhone}</div>
                    ) : null}
                    {giftDeliveryDetails.senderDOB ? (
                      <div className="description">{`SENDER DOB: ${giftDeliveryDetails.senderDOB ? Moment(giftDeliveryDetails.senderDOB).format('L') : 'Not provided'}`}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="info-row">
            <div className="content-left has-label">
              <div className="info-row-label">Delivery Notes</div>
              <div className="info-row-value">{deliveryNotes
                ? deliveryNotes
                : 'Not provided'}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="info-row">
            <div className="content-left has-label">
              <div className="info-row-label">Schedule Delivery</div>
              <div className="info-row-value">{isTimeNowSelected
                ? 'Now'
                : `${Moment(deliveryTime.start).format('MM-DD-YYYY')}, ${deliveryTime.start ? Moment(deliveryTime.start).format('hh:mma') : ''}${deliveryTime.end ? ' - ' + Moment(deliveryTime.end).format('hh:mma') : ''}`}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderGiftDeliverySwitchRow() {
    const {onGiftSwitchToggle, isGiftSwitchOn} = this.props;
    return (
      <div className="row">
        <div className="info-row">
          <div className="content-left">Gift Delivery</div>
          <div className="content-right">
            <input
              className="tgl tgl-light"
              id="gift-switch"
              onChange={() => onGiftSwitchToggle ? onGiftSwitchToggle() : null}
              checked={isGiftSwitchOn}
              type="checkbox" />
              <label className="tgl-btn" htmlFor="gift-switch"></label>
          </div>
        </div>
        {
          isGiftSwitchOn ? <div className="covid-message">
            {/* Due to the Covid-19 circumstance, dates and time are not guaranteed. Thank you for your understanding. */}
            </div> : null
        }
      </div>
    )
  }

  renderGiftDeliveryAddress() {
    const {
      giftDeliveryDetails,
      onChangeDeliveryDetailsForm,
      openSenderAddressModal
    } = this.props;
    const {deliveryValidationStatus} = this.state;
    const {
      recipientAddress,
      recipientName,
      recipientEmail,
      recipientPhone,
      recipientBusinessName,
      giftMessage,
      senderAddress,
      senderName,
      senderEmail,
      senderPhone,
      senderBusinessName,
      senderDOB
    } = giftDeliveryDetails ? giftDeliveryDetails : {};

    return (
      <div>
        <div className="row">
          <div className="section-title">Recipient Details</div>
          {recipientAddress ? (
            <div className="info-row" onClick={() => this.setState({recipientAddressPickerModalVisibility: true})}>
              <div className="content-left has-label">
                <div className="info-row-label">Recipient Address</div>
                <div className="info-row-value">
                  <div>{recipientAddress.apartment ? `Apartment #: ${recipientAddress.apartment}` : ''}</div>
                  <div>{recipientAddress.description}</div>
                </div>
              </div>
              <div className="content-right"><i className="fa fa-angle-right icon" /></div>
            </div>
          ) : (
            <div className="info-row picker-row" onClick={() => this.setState({recipientAddressPickerModalVisibility: true})}>
              <div className="content-left">Select Recipient Address</div>
              <div className="content-right"><i className="fa fa-angle-right icon" /></div>
            </div>
          )}

          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="RECIPIENT NAME"
                aria-label="RECIPIENT NAME"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ recipientName: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={recipientName} />
            </div>
          </div>
          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="RECIPIENT EMAIL (OPTIONAL)"
                aria-label="RECIPIENT EMAIL (OPTIONAL)"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ recipientEmail: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={recipientEmail} />
            </div>
          </div>
          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="RECIPIENT PHONE" type="number"
                aria-label="RECIPIENT PHONE"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ recipientPhone: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={recipientPhone} />
            </div>
          </div>
          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="RECIPIENT BUSINESS NAME (OPTIONAL)"
                aria-label="RECIPIENT BUSINESS NAME (OPTIONAL)"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ recipientBusinessName: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={recipientBusinessName} />
            </div>
          </div>
          <div className="info-row textarea-row">
            <div className="content-left">
              <textarea placeholder="GIFT MESSAGE" aria-label="GIFT MESSAGE" className="gift-messsage"
                onChange={(e) => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ 'giftMessage': e.target.value }) : null}
                value={giftMessage}></textarea>
            </div>
          </div>

        </div>
        {deliveryValidationStatus && deliveryValidationStatus.status && deliveryValidationStatus.time ?

            <div className="row">
            <div className="col-sm-12">
                <p className="text-info">{`* For this recepient address, we will need at least ${deliveryValidationStatus.timeDisplay} to deliver.`}</p>
            </div>
            </div>
            : null
        }

        <div className="row">
          <div className="section-title">Sender Details</div>
          {senderAddress ? (
            <div className="info-row" onClick={() => this.setState({senderAddressPickerModalVisibility: true})}>
              <div className="content-left has-label">
                <div className="info-row-label">Recipient Address</div>
                <div className="info-row-value">
                  <div>{senderAddress.apartment ? `Apartment #: ${senderAddress.apartment}` : ''}</div>
                  <div>{senderAddress.description}</div>
                </div>
              </div>
              <div className="content-right"><i className="fa fa-angle-right icon" /></div>
            </div>
          ) : (
            <div className="info-row" onClick={() => this.setState({senderAddressPickerModalVisibility: true})}>
              <div className="content-left">Select Sender Address (OPTIONAL)</div>
              <div className="content-right"><i className="fa fa-angle-right icon" /></div>
            </div>
          )}

          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="SENDER NAME (OPTIONAL)"
                aria-label="SENDER NAME (OPTIONAL)"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ senderName: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={senderName} />
            </div>
          </div>
          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="SENDER EMAIL (OPTIONAL)"
                aria-label="SENDER EMAIL (OPTIONAL)"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ senderEmail: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={senderEmail} />
            </div>
          </div>
          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="SENDER PHONE (OPTIONAL)" type="number"
                aria-label="SENDER PHONE (OPTIONAL)"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ senderPhone: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={senderPhone} />
            </div>
          </div>
          {senderPhone == recipientPhone ? <div className="phone-error">Recipient and sender phone numbers can't be the same.</div> : null}
          <div className="info-row text-input-row">
            <div className="content-left">
              <input placeholder="SENDER BUSINESS NAME (OPTIONAL)"
                aria-label="SENDER BUSINESS NAME (OPTIONAL)"
                onChange={e => onChangeDeliveryDetailsForm ? onChangeDeliveryDetailsForm({ senderBusinessName: e.target.value, isDeliveryDetailsEdited: true }) : null}
                value={senderBusinessName} />
            </div>
          </div>
          <div className="info-row text-input-row">
            <div className="content-left">
              <DatePicker
                selected={senderDOB}
                dateFormat="MM/DD/YYYY"
                dropdownMode="select"
                maxDate={Moment().subtract(21, 'years')}
                showMonthDropdown
                showYearDropdown
                placeholderText="SENDER DOB (MM/DD/YYYY)"
                onChange={value => onChangeDeliveryDetailsForm
                  ? onChangeDeliveryDetailsForm({ senderDOB: value, isDeliveryDetailsEdited: true })
                  : null}/>
            </div>
            <div className="content-right"><i className="fa fa-angle-right icon" /></div>
          </div>

        </div>

      </div>
    )
  }

  renderDeliveryToAddress() {
    const { userAddresses, deliveryAddress, onSelectUserAddress, addNewAddress,
      deliveryTime, onDeliveryTimeSelected, viewMode, deliveryValidationStatus } = this.props;
    const { deliveryTimePickerVisibility } = this.state;

    console.log("DELIVERY_DETAILS_MOBILE_PROPS", this.props);
    return (
      <div className="row user-addresses-container">
        <div className="section-title">Delivery Addresses</div>
        {userAddresses
          ? (userAddresses.map(address => {
            return (
              <div key={address._id} className={`info-row column ${deliveryAddress && deliveryAddress._id === address._id && deliveryValidationStatus && deliveryValidationStatus.time ? 'delivery-status':''}`}>
                <div className="info-row" key={address._id} onClick={() => onSelectUserAddress ? onSelectUserAddress(address) : null}>
                  <div className="content-left info-delivery-address">
                    {address.apartment ? `Apartment #: ${address.apartment}, ${address.description}` : address.description}
                  </div>
                  {viewMode && viewMode === 'select'
                    ? (
                      <div className="content-right">
                        <i className={`fa fa${deliveryAddress && (deliveryAddress._id === address._id) ? '-circle' : '-circle-o'} icon`} />
                      </div>
                    )
                    : null}
                </div>
                { (deliveryAddress && deliveryAddress._id === address._id && deliveryValidationStatus && deliveryValidationStatus.status && !!deliveryValidationStatus.time) && 
                  <span className="text-info no-space">{`* We will need at least ${deliveryValidationStatus.timeDisplay} to deliver to this address.`}</span>
                }
              </div>
            )
          }))
          : null}

          {viewMode && (viewMode === 'edit' || viewMode === 'select')
            ? (
                <div className="info-row add-address-row" onClick={() => addNewAddress ? addNewAddress() : null}>
                  <div className="content-left"><i className="fa fa-plus-circle" />Add New Address</div>
                  <div className="content-right"><i className="fa fa-angle-right icon" /></div>
                </div>
              )
            : null}
      </div>
    )
  }

  renderDeliveryNotes() {
    const { deliveryNotes, onChangeDeliveryNotes } = this.props;
    return (
      <div className="row">
        <div className="section-title">Delivery Notes</div>
        <div className="info-row textarea-row">
          <div className="content-left">
            <textarea placeholder="Enter delivery notes..."
            aria-label="Enter delivery notes"
              onChange={e => onChangeDeliveryNotes
                ? onChangeDeliveryNotes(e.target.value)
                : this.setState({ deliveryNotes: e.target.value })}
              value={deliveryNotes}></textarea>
          </div>
        </div>
      </div>
    )
  }

  renderScheduleDelivery() {
    const { isTimeNowSelected, deliveryTime, onTimeNowSelected, deliveryValidationStatus, 
      deliverySlot, onSlotChange, isGiftSwitchOn } = this.props;

    const deliveryTimeInterval = {};
    if (isTimeNowSelected)
      deliveryTimeInterval.start = 'now';
    else if (deliverySlot && !isGiftSwitchOn) {
      deliveryTimeInterval.start = Moment(deliveryTime)
        .hour(slots[deliverySlot][0]).minute(0);
      deliveryTimeInterval.end = Moment(deliveryTime)
        .hour(slots[deliverySlot][1]).minute(0);
    }
    else {
      deliveryTimeInterval.start = Moment(deliveryTime);
      deliveryTimeInterval.end = Moment(deliveryTime).add(60, 'minutes');
    }
    return (
      <div className="row">
        { this.props.deliveryValidationStatus.region === 'SHIPPO' ?
        <div className={this.props.shippoData.length > 0 ? "shippo-mobile" : "fetching-message"}>
        {
            this.props.shippoData && this.props.shippoData.length > 0 ? this.props.shippoData.map(data => { 
            return(
             <div className="shippo-details-mobile" key={data.object_id}  onClick={() => this.props.shipmentSelected(data)}> 
                <div className={`card-shippo-mobile ${data.object_id == this.props.makeCardActive ? 'active-selected-mobile' : ''}`}>
                  <div className="shippo-provider-name-mobile">
                    <div className="details-mobile">Shipping provider: {data.provider}</div>
                    <div className="details-mobile">No of Estimated Days: {data.estimated_days}</div>
                    <div className="details-mobile">Amount: ${data.amount}</div>
                  </div>
                  <img className="provider-logo-mobile" src={data.provider_image_200} alt="provider_logo_missing"/>
                </div>
              </div>
            )
          }) : "Fetching Shipping Options...."
        } 
      </div> 
      :
      <div className="current-delivery-mobile">
        <div className="section-title">Schedule Delivery</div>
         { (!deliveryValidationStatus.time) && <div className="info-row" onClick={() => onTimeNowSelected ? onTimeNowSelected(true) : null}>
          <div className="content-left">
            <i className={`fa fa${isTimeNowSelected ? '-dot' : ''}-circle-o`} />
            <span>Now</span>
          </div>
        </div> }
        <div className="info-row" onClick={() => this.onSelectCustomTimeRequest()}>
          <div className="content-left">
            <i className={`fa fa${isTimeNowSelected ? '' : '-dot'}-circle-o`} />
            <span>
              {isTimeNowSelected
                ? 'Custom'
                : deliveryTime && `${deliveryTime.format('MM-DD-YYYY')}, ${deliveryTimeInterval.start.format('hh:mma')}${' - ' + (deliveryTimeInterval.end.format('hh:mma'))}`}
            </span>
          </div>
          <div className="content-right">
            {!isTimeNowSelected ? (<i className="fa fa-angle-right icon" />) : null}
          </div>
        </div>

        { (!!deliveryValidationStatus.time && !isGiftSwitchOn) && <div className="section-title">Delivery Slots</div> }
        { (!!deliveryValidationStatus.time && !isGiftSwitchOn) &&
          <div className="info-row column">
            <div className="info-row" onClick={() => onSlotChange('morning')}>
              <div className="content-left">
                <i className={`fa ${deliverySlot === 'morning' ? 'fa-dot-circle-o' : 'fa-circle-o'}`} />
                <span>Morning (9am to 12 noon)</span>
              </div>
            </div>
            <div className="info-row" onClick={() => onSlotChange('afternoon')}>
              <div className="content-left">
                <i className={`fa ${deliverySlot === 'afternoon' ? 'fa-dot-circle-o' : 'fa-circle-o'}`} />
                <span>Afternoon (12pm to 3pm)</span>
              </div>
            </div>
            <div className="info-row" onClick={() => onSlotChange('evening')}>
              <div className="content-left">
                <i className={`fa ${deliverySlot === 'evening' ? 'fa-dot-circle-o' : 'fa-circle-o'}`} />
                <span>Evening (3pm to 9pm)</span>
              </div>
            </div>
          </div>
        }
        </div>}
      </div>
      )
  }

  renderDeliveryScheduleInfo() {
    return (
      <div className="row info-schedule-container">
        <div className="info title">Hours of Operations:</div>
        <div className="info">Mon – Sun: 9am to 2am</div>
        <div className="info">365 days!<br />Delivery available ALL DAY!</div>
      </div>
    )
  }

  onSelectCustomTimeRequest() {
    const {onTimeNowSelected} = this.props;
    if(!!onTimeNowSelected) {
      onTimeNowSelected(false);
    }
    this.setState({ deliveryTimePickerVisibility: true })
  }

}

export default DeliveryDetailsMobile;



// WEBPACK FOOTER //
// ./src/components/checkout/DeliveryDetailsMobile.js